import { render } from "./ediService.vue?vue&type=template&id=e2cead60&lang=true"
import script from "./ediService.vue?vue&type=script&lang=js"
export * from "./ediService.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__